export default __webpack_public_path__ + "static/media/ActionMask.0dc7f85f.svg";